import { render, staticRenderFns } from "./TourSystem.vue?vue&type=template&id=1f0faf39&scoped=true"
import script from "./TourSystem.vue?vue&type=script&lang=js"
export * from "./TourSystem.vue?vue&type=script&lang=js"
import style0 from "./TourSystem.vue?vue&type=style&index=0&id=1f0faf39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0faf39",
  null
  
)

export default component.exports